export class Pool {
    static getPoolBySign(sign) {
        return Pool._poolDic[sign] || (Pool._poolDic[sign] = []);
    }
    static clearBySign(sign) {
        if (Pool._poolDic[sign])
            Pool._poolDic[sign].length = 0;
    }
    static recover(sign, item) {
        if (item[Pool.POOLSIGN])
            return;
        item[Pool.POOLSIGN] = true;
        Pool.getPoolBySign(sign).push(item);
    }
    static recoverByClass(instance) {
        if (instance) {
            var className = instance["__className"] || instance.constructor._$gid;
            if (className)
                Pool.recover(className, instance);
        }
    }
    static _getClassSign(cla) {
        var className = cla["__className"] || cla["_$gid"];
        if (!className) {
            cla["_$gid"] = className = Pool._CLSID + "";
            Pool._CLSID++;
        }
        return className;
    }
    static createByClass(cls) {
        return Pool.getItemByClass(Pool._getClassSign(cls), cls);
    }
    static getItemByClass(sign, cls) {
        let rst;
        let pool = Pool.getPoolBySign(sign);
        if (pool.length)
            rst = pool.pop();
        else
            rst = new cls();
        rst[Pool.POOLSIGN] = false;
        return rst;
    }
    static getItemByCreateFun(sign, createFun, caller = null) {
        var pool = Pool.getPoolBySign(sign);
        var rst = pool.length ? pool.pop() : createFun.call(caller);
        rst[Pool.POOLSIGN] = false;
        return rst;
    }
    static getItem(sign) {
        var pool = Pool.getPoolBySign(sign);
        var rst = pool.length ? pool.pop() : null;
        if (rst) {
            rst[Pool.POOLSIGN] = false;
        }
        return rst;
    }
    static createPool(type, init, reset) {
        let p = new SimplePool();
        p._ct = type;
        p._init = init;
        p._reset = reset;
        return p;
    }
    static createPool2(create, init, reset) {
        let p = new SimplePool();
        p._create = create;
        p._init = init;
        p._reset = reset;
        return p;
    }
}
Pool._CLSID = 0;
Pool.POOLSIGN = "__InPool";
Pool._poolDic = {};
class SimplePool {
    constructor() {
        this.pool = [];
    }
    take(...args) {
        let ret;
        if (this.pool.length > 0)
            ret = this.pool.pop();
        else if (this._create)
            ret = this._create();
        else
            ret = new this._ct();
        if (this._init)
            this._init(ret, ...args);
        return ret;
    }
    recover(element) {
        if (Array.isArray(element)) {
            for (let i = 0, n = element.length; i < n; i++) {
                let e = element[i];
                if (this._reset)
                    this._reset(e);
                this.pool.push(e);
            }
            element.length = 0;
        }
        else {
            if (this._reset)
                this._reset(element);
            this.pool.push(element);
        }
    }
}
